import { render } from "./MonthlyFour.vue?vue&type=template&id=80c40bfc"
import script from "./MonthlyFour.vue?vue&type=script&lang=js"
export * from "./MonthlyFour.vue?vue&type=script&lang=js"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__